import { ValueOf } from "../type";

export const FolderSharingKey = {
  FolderSharings: "FOLDER_SHARINGS",
} as const;

export type FolderSharingKeyType = ValueOf<typeof FolderSharingKey>;
